import { DetailedHTMLProps, FormHTMLAttributes, forwardRef, PropsWithChildren } from 'react';

import { tv, VariantProps } from 'tailwind-variants';

import { SlotsToClasses } from '@anyx/shared-ui';


const styles = tv({
  slots: {
    root: 'flex flex-col',
    container: 'flex grow flex-col gap-7 px-6 pt-8 pb-6',
  },
  variants: {
    size: {
      md: {
        root: 'w-120 min-w-120',
      },
      lg: {
        root: 'w-140 min-w-140',
      },
    },
  },
});

type Size = VariantProps<typeof styles>['size'];
type AnyChatFormSlots = keyof ReturnType<typeof styles>;

export interface FormProps extends DetailedHTMLProps<
  FormHTMLAttributes<HTMLFormElement>,
  HTMLFormElement
> {
  /** md - 30rem | lg - 39rem */
  size?: Size;
  classNames?: SlotsToClasses<AnyChatFormSlots>;
}

export const Form = forwardRef<HTMLFormElement, PropsWithChildren<FormProps>>(
  ({ size = 'md', classNames, children, className, ...props }, ref) => {
    const { root, container } = styles({ size });
    return (
      <form ref={ref} className={root({ class: [className, classNames?.root] })} {...props}>
        <div className={container({ class: classNames?.container })}>{children}</div>
      </form>
    );
  }
);
